import React, { useRef, useState, useEffect } from "react";
import Layout from "components/layout/Layout";
import localization from "assets/localization/localization";
import { BaseUrl } from "context/baseUrl/baseUrl";
import { Link, useHistory } from "react-router-dom";
import {
  checkEmpty,
  dateParser,
} from "services/utils/commonFunctions/CommonFunctions";
import FormSection from "components/form/FormSection";
import Images from "assets/images/imageData";
import Loader from "components/loader/loader";
import { trim } from "lodash";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
// import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Partners.scss";
import MainLayout from "components/mainLayout/MainLayout";
import PartnerBox from "./PartnerBox";
import callWebService, { callTypes } from "services/utils/networks/network";
import Config from "services/config/config";
import ConstVar from "constants/const";
import DropdownFilter from "components/input/dropdown/dropDownFilter";
// import CustomModal from "components/modal/modal";

const Partners = ({ match }) => {
  const [smallModal, setSmallModal] = useState({
    hover1: false,
    hover2: false,
    show: false,
  });
  const [activeComponent, setActiveComponent] = useState();
  const [errorMsg, setErrorMsg] = useState("");
  const [totalRecord, setTotalRecord] = useState(0);
  const [successMsg, setSuccessMsg] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [addPartnerData, setAddPartnerData] = useState({
    partnerName: "",
    partnerCode: "",
    partnerEmail: "",
    partnerWebhookUrl: "",
    coolOffPeriod: "",
    partnerId: null,
    crmProductVerification: "false",
    partnerHeaders: "",
  });
  const [errMsg, setErrMsg] = useState({
    partnerName: "",
    partnerCode: "",
    partnerEmail: "",
    partnerWebhookUrl: "",
    coolOffPeriod: "",
    partnerHeaders: "",
  });

  const history = useHistory();
  const scrl = useRef(null);

  useEffect(() => {
    (async () => {
      getPartnerData();
      setPageNo(1);
    })();
  }, []);

  const recordsPerPage = [
    { records_id: 10, records_value: 10 },
    { records_id: 20, records_value: 20 },
    { records_id: 30, records_value: 30 },
    { records_id: 50, records_value: 50 },
  ];

  const handleRecordsPerPage = async (recordSize) => {
    setPageNo(1);
    if (oldData) {
      setPartnerData(oldData.slice(0, recordSize));
    }
    setPerPageRecord(recordSize);
    setisLoading(false);
  };

  const [isLoading, setisLoading] = useState(true);
  const [dataList, setdataList] = useState([]);
  const [pageNos, setPageNo] = useState("1");
  const [show, setShow] = useState(false);
  const [historyShow, setHistoryShow] = useState(false);
  const [perPageRecord, setPerPageRecord] = useState(10);
  const [partnerData, setPartnerData] = useState([]);
  const [partnerHistoryData, setPartnerHistoryData] = useState([]);
  const [partnerName, setPartnerName] = useState("");
  const [editPartner, setEditPartner] = useState(false);
  const [editPartnerData, setEditPartnerData] = useState({});
  const [partnerDisable, setPartnerDisable] = useState(false);
  const [coolMaxLength, setCoolMaxLength] = useState("");
  const [isCheck, setIsCheck] = useState([]);
  const [oldData, setOldData] = useState([]);

  const getPartnerData = async (page, reqType) => {
    setPageNo(page ? page : 1);
    const data = {
      searchName: partnerName !== "" ? trim(partnerName) : "",
      pageNo: page ? page : 1,
      pageSize: perPageRecord ? perPageRecord : 10,
    };
    setisLoading(true);
    const res = await callWebService(
      callTypes.post,
      data,
      Config.partnerDetails
    );
    setisLoading(false);
    const { partnerList, pagination } = res.data.data;
    setOldData(partnerList);
    if (partnerList) {
      setPartnerData(partnerList.slice(0, 10));
    }
    setPerPageRecord(pagination?.pre_page_records);
    setTotalRecord(res?.data?.data?.pagination?.total_rows);
  };

  const handleAscendingOrder = () => {};

  const handleDescendingOrder = () => {};

  const renderHeader = () => {
    let headerElement = [
      "S. No.",
      "Name",
      "Email",
      "Partner code",
      "Cool Off Period",
      "Created At",
      "Webhook url",
    ];

    return headerElement.map((key, index) => {
      if (key === "Applicant Name" || key === "Order Date") {
        return (
          <th>
            {key}
            &nbsp;
            <div>
              <button
                className="btn-sorting"
                type="button"
                onClick={() => handleAscendingOrder()}
              >
                <img src={Images?.stickUpArrow} alt="" />
              </button>
              <button
                className="btn-sorting"
                type="button"
                aria-haspopup="true"
                aria-expanded="false"
                onClick={() => handleDescendingOrder()}
              >
                <img src={Images?.stickDownArrow} alt="" />
              </button>
            </div>
          </th>
        );
      } else {
        return <th key={index}>{key}</th>;
      }
    });
  };

  const onChangeFilter = async (e) => {
    const data = e.target.value;
    setPartnerName(data);
    if (!data) {
      getPartnerData();
    }
  };

  const filterData = () => {
    const partnerData = trim(partnerName);
    if (partnerData) {
      setPartnerName(partnerData);
      const filterData = oldData?.filter(
        (item) => trim(item.name) == partnerData
      );
      setPartnerData(filterData);
    }
  };

  const reFreshData = () => {
    document.location.reload();
  };
  const nextEndPage = (page) => {
    setPageNo(page);
    const records = page * perPageRecord;
    const pageOne = records - perPageRecord;
    if (oldData) {
      setPartnerData(oldData.slice(pageOne, records));
    }
  };

  const previousStartPage = (page) => {
    const records = page * perPageRecord;
    const pageOne = records - perPageRecord;
    setPageNo(page);
    if (oldData) {
      setPartnerData(oldData.slice(pageOne, records));
    }
  };

  const handleClose = () => {
    setShow(false);
    setEditPartner(true);
    setAddPartnerData({
      partnerName: "",
      partnerCode: "",
      partnerEmail: "",
      partnerWebhookUrl: "",
      coolOffPeriod: "",
      partnerId: null,
      crmProductVerification: "false",
    });
    setErrMsg({
      partnerName: "",
      partnerCode: "",
      partnerEmail: "",
      partnerWebhookUrl: "",
      coolOffPeriod: "",
    });
  };
  const handleShow = () => {
    setShow(true);
    setPartnerDisable(false);
    setEditPartner(false);
  };

  const partnerChange = (e) => {
    const { name, value } = e.target;

    if (name === "coolOffPeriod") {
      if (value.length >= 4) {
        setErrMsg({
          coolOffPeriod: "",
        });
        setCoolMaxLength("Please enter maximum length 3");
        return;
      } else {
        setCoolMaxLength("");
      }
    } else if (name === "partnerName") {
      if (value.length >= 26) {
        setErrMsg((state) => ({
          ...state,
          partnerName: "Please enter maximum length 25",
        }));
        return;
      } else {
        setErrMsg((state) => ({ ...state, partnerName: "" }));
      }
    } else if (name === "partnerCode") {
      if (value.length >= 26) {
        setErrMsg((state) => ({
          ...state,
          partnerCode: "Please enter maximum length 25",
        }));
        return;
      } else {
        setErrMsg((state) => ({ ...state, partnerCode: "" }));
      }
    } else if (name === "partnerEmail") {
      if (value.length >= 51) {
        setErrMsg((state) => ({
          ...state,
          partnerEmail: "Please enter maximum length 50",
        }));
        return;
      } else {
        setErrMsg((state) => ({ ...state, partnerEmail: "" }));
      }
    } else if (name === "partnerWebhookUrl") {
      if (value.length >= 101) {
        setErrMsg((state) => ({
          ...state,
          partnerWebhookUrl: "Please enter maximum length 100",
        }));
        return;
      } else {
        setErrMsg((state) => ({ ...state, partnerWebhookUrl: "" }));
      }
    }
    setAddPartnerData((state) => ({
      ...state,
      [name]: ["partnerName", "partnerCode"].includes(name)
        ? value.replace(/[^\w\s]/gi, "")
        : value,
    }));
  };

  const handleSubmit = async () => {
    //working email
    const emailRegex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"0-9]{2,})$/i;
    const urlRegex1 = /(http[s]?:\/\/)+[^\s(["<,>]*\.[^\s[",><]*/gim;

    const nameRegex = /^[^-\s][a-zA-Z0-9_\s-]+$/;

    if (
      addPartnerData.partnerName === "" ||
      nameRegex.test(addPartnerData.partnerName) === false
    ) {
      setErrMsg((state) => ({ ...state, partnerName: "Enter partner name" }));
      return;
    } else {
      setErrMsg((state) => ({ ...state, partnerName: "" }));
    }
    if (
      addPartnerData.partnerCode === "" ||
      nameRegex.test(addPartnerData.partnerCode) === false
    ) {
      setErrMsg((state) => ({ ...state, partnerCode: "Enter partner code" }));
      return;
    } else {
      setErrMsg((state) => ({ ...state, partnerCode: "" }));
    }
    if (
      addPartnerData.partnerEmail === "" ||
      emailRegex.test(addPartnerData.partnerEmail) === false
    ) {
      setErrMsg((state) => ({ ...state, partnerEmail: "Enter partner email" }));
      return;
    } else {
      setErrMsg((state) => ({ ...state, partnerEmail: "" }));
    }
    if (
      addPartnerData.partnerWebhookUrl === "" ||
      urlRegex1.test(addPartnerData.partnerWebhookUrl) === false
    ) {
      setErrMsg((state) => ({
        ...state,
        partnerWebhookUrl:
          addPartnerData.partnerWebhookUrl === ""
            ? "Enter partner webhook url"
            : "Enter partner webhook url with http or https",
      }));
      return;
    } else {
      setErrMsg((state) => ({ ...state, partnerWebhookUrl: "" }));
    }
    const coolData = addPartnerData.coolOffPeriod;

    if (addPartnerData.coolOffPeriod === "") {
      setErrMsg((state) => ({
        ...state,
        coolOffPeriod: "Enter cool off period",
      }));
      return;
    } else {
      setErrMsg((state) => ({ ...state, coolOffPeriod: "" }));
    }

    setIsSubmit(true);

    const userName = localStorage.getItem("username");
    const data = {
      name: addPartnerData.partnerName?.trim(),
      code: addPartnerData.partnerCode?.trim(),
      email: addPartnerData.partnerEmail,
      webhookUrl: addPartnerData.partnerWebhookUrl?.trim(),
      coolOffPeriod: addPartnerData.coolOffPeriod,
      partnerId: addPartnerData.partnerId,
      crmproductverification: JSON.parse(addPartnerData.crmProductVerification),
      username: userName,
      partner_headers: JSON.stringify(addPartnerData.partnerHeaders),
    };
    const res = await callWebService(callTypes.post, data, Config.addPartner);
    if (res.data.code === 200 || res.data.code === true) {
      setErrorMsg("");
      setSuccessMsg(res.data.message);
      setIsSubmit(false);
      setAddPartnerData({
        partnerName: "",
        partnerCode: "",
        partnerEmail: "",
        partnerWebhookUrl: "",
        coolOffPeriod: "",
        partnerId: null,
      });
      setErrMsg({
        partnerName: "",
        partnerCode: "",
        partnerEmail: "",
        partnerWebhookUrl: "",
        coolOffPeriod: "",
      });
      setTimeout(() => {
        document.location.reload();
      }, 500);
    } else if (res.data.code === 400) {
      setErrorMsg(res.data.data[0].message);
      setIsSubmit(false);
    }
  };

  //edit partner
  const editPartnerDetail = (data) => {
    setShow(true);
    setEditPartner(true);
    setEditPartnerData(data);
    const partnerCode = data.partner_code !== "";
    setPartnerDisable(partnerCode ? true : false);
    const partnerEditObj = {
      partnerName: data.name,
      partnerCode: data.partner_code,
      partnerEmail: data.email,
      partnerWebhookUrl: data.webhook_url,
      coolOffPeriod: data.cooloffperiod,
      crmProductVerification: data?.crmproductverification?.toString(),
      partnerId: data.id,
      partnerHeaders: data.partner_headers,
    };
    setAddPartnerData(partnerEditObj);
  };

  //partner history list
  const partnerHistory = async () => {
    setisLoading(true);
    const res = await callWebService(callTypes.post, {}, Config.partnerHistory);
    console.log("PATNER HIDIOST DATA", res);
    setisLoading(false);
    const { partnerHistoryList, pagination } = res.data.data;
    setPartnerHistoryData(partnerHistoryList);
    // setPerPageRecord(pagination?.pre_page_records);
    // setTotalRecord
  };

  //view history
  const viewPartnerHistory = () => {
    partnerHistory();
    setHistoryShow(true);
  };

  const handleHistoryClose = () => {
    setHistoryShow(false);
  };

  const inputSearch = () => {
    return (
      <>
        <div style={{ display: "inline-block" }}>
          <input
            type="text"
            className="search-button"
            name="search"
            value={partnerName || ""}
            placeholder="Search Name..."
            onChange={(e) => onChangeFilter(e)}
          />
          &nbsp;
          <button className="btn btn-primary" onClick={() => filterData()}>
            Search
          </button>
          &nbsp;
          <button className="btn btn-warning" onClick={() => reFreshData()}>
            Reset
          </button>
        </div>

        <div style={{ float: "right", position: "relative" }}>
          {partnerData && partnerData.length > 0 ? (
            <b
              className="pagination-value"
              data-hovered={smallModal.hover1}
              style={{ cursor: "pointer" }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover1: false, hover2: false });
              }}
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover1: true, show: true });
              }}
            >
              {pageNos == 1 ? pageNos : (pageNos - 1) * perPageRecord + 1}-
              {pageNos * perPageRecord > totalRecord
                ? totalRecord
                : pageNos * perPageRecord}{" "}
              of {totalRecord}
            </b>
          ) : (
            <span className="pagination-value">0 - 0 of 0</span>
          )}
          &nbsp;
          {smallModal.hover1 && (
            <div
              className="small-modal"
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover2: true });
              }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover2: false, hover1: false });
              }}
            >
              <span
                className="small-modal-option"
                data-disabled={pageNos === 1 && true}
                onClick={() => previousStartPage(1)}
              >
                Newest
              </span>
              <span
                className="small-modal-option"
                data-disabled={totalRecord <= pageNos * perPageRecord && true}
                onClick={() =>
                  previousStartPage(Math.ceil(totalRecord / perPageRecord))
                }
              >
                Oldest
              </span>
            </div>
          )}
          <button
            className="pagination-button"
            onClick={() => previousStartPage(pageNos - 1)}
            title="Newer"
            data-disabled={pageNos <= 1 && true}
            disabled={pageNos <= 1}
          >
            {"<"}
          </button>
          &nbsp;
          <button
            className="pagination-button"
            onClick={() => nextEndPage(pageNos + 1)}
            title="Older"
            data-disabled={
              totalRecord <= pageNos * perPageRecord || partnerData.length === 0
            }
            disabled={
              totalRecord <= pageNos * perPageRecord || partnerData.length === 0
            }
          >
            {">"}
          </button>
        </div>
      </>
    );
  };

  const handleCancel = () => {
    setShow(false);
  };

  const filterSearch = () => {};

  const blockInvalidChar = (e) => {
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
  };

  return (
    <BaseUrl.Provider value={{ baseUrl: match.url }}>
      <MainLayout activeComponent={activeComponent} match={match}>
        <Layout
          title={localization.allPartners}
          isLoading={false}
          isGoback={true}
          className={"desktop-view"}
        >
          {/* {inputSearch()} */}
          <FormSection
            search={true}
            inputSearch={inputSearch}
            filterSearch={filterSearch}
            sortBy={() => {}}
            isCheck={isCheck}
          >
            <div
              className="panel-card-table"
              ref={scrl}
              style={{ width: "100%", overflow: "auto" }}
            >
              <table id="employee" className="table table-bordered">
                <thead>
                  <tr>{renderHeader()}</tr>
                </thead>
                <tbody>
                  {partnerData &&
                    partnerData.map((data, idx) => (
                      <tr key={idx}>
                        <td>
                          {pageNos === 1
                            ? idx + 1
                            : (pageNos - 1) * perPageRecord + idx + 1}
                        </td>
                        <td>{data.name}</td>
                        <td>{data.email}</td>
                        <td>{data.partner_code}</td>
                        <td>{data.cooloffperiod}</td>
                        <td>
                          {data.created_at
                            ? dateParser(
                                data.created_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {data.created_at
                            ? dateParser(
                                data.created_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>

                        <td>{data.webhook_url}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div style={{ maxWidth: "150px" }}>
              <DropdownFilter
                optIdKey="records_id"
                optValueKey="records_value"
                optionList={recordsPerPage}
                placeholder="Records Per Page"
                onChange={(event) => {
                  setPerPageRecord(event.target.value);
                  handleRecordsPerPage(event.target.value);
                }}
                value={perPageRecord}
              />
            </div>
          </FormSection>
          <Loader isLoading={isLoading} />

          <Modal className="dms-modal" show={show} onHide={handleClose}>
            <Modal.Header closeButton style={{ backgroundColor: "#f7fcfd" }}>
              <Modal.Title>
                {editPartner ? "Edit Partner" : "Add Partner"} &nbsp;
                <span
                  style={{
                    color: successMsg ? "green" : "red",
                    fontSize: "small",
                  }}
                >
                  {successMsg ? successMsg : errorMsg}
                </span>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ textAlign: "" }} className="partner-p">
              <Col>
                <label className="mt-3">Partner Name </label>
                <input
                  type="text"
                  className="search-button partner-search"
                  name="partnerName"
                  placeholder="Partner Name..."
                  value={addPartnerData.partnerName || ""}
                  onChange={(e) => partnerChange(e)}
                />
                <br />
                <span style={{ color: "red" }}>{errMsg.partnerName}</span>
              </Col>
              <Col>
                <label className="mt-3">Partner Code </label>
                <input
                  type="text"
                  name="partnerCode"
                  className="search-button partner-search"
                  placeholder="Partner Code..."
                  value={addPartnerData.partnerCode || ""}
                  onChange={(e) => partnerChange(e)}
                  disabled={partnerDisable}
                  style={{ backgroundColor: partnerDisable ? "#ced4da" : "" }}
                />
                <br />
                <span style={{ color: "red" }}>{errMsg.partnerCode}</span>
              </Col>
              <Col>
                <label className="mt-3">Partner Email </label>
                <input
                  type="email"
                  name="partnerEmail"
                  className="search-button partner-search"
                  placeholder="Partner Email..."
                  value={addPartnerData.partnerEmail || ""}
                  onChange={(e) => partnerChange(e)}
                />
                <br />
                <span style={{ color: "red" }}>{errMsg.partnerEmail}</span>
              </Col>
              <Col>
                <label className="mt-3">Partner Webhook Url </label>
                <input
                  type="url"
                  name="partnerWebhookUrl"
                  className="search-button partner-search"
                  placeholder="Partner Webhook Url..."
                  value={addPartnerData.partnerWebhookUrl || ""}
                  onChange={(e) => partnerChange(e)}
                />
                <br />
                <span style={{ color: "red" }}>{errMsg.partnerWebhookUrl}</span>
              </Col>
              <Col>
                <label className="mt-3">Cool Off period </label>
                <input
                  type="number"
                  name="coolOffPeriod"
                  min="1"
                  maxLength="3"
                  pattern="([0-9]|[0-9]|[0-9])"
                  className="search-button partner-search"
                  placeholder="Cool Off Period..."
                  value={addPartnerData.coolOffPeriod || ""}
                  onChange={(e) => partnerChange(e)}
                  onKeyDown={blockInvalidChar}
                />

                <br />
                <span style={{ color: "red" }}>
                  {errMsg.coolOffPeriod ? errMsg.coolOffPeriod : coolMaxLength}
                </span>
              </Col>
              <Col>
                <label className="mt-3">CRM Product Auto verification </label>
                <br />
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="crmProductVerification"
                    id="inlineRadio1"
                    value="true"
                    onChange={(e) => partnerChange(e)}
                    checked={addPartnerData.crmProductVerification == "true"}
                  />
                  <label className="form-check-label" htmlFor="inlineRadio1">
                    Enable
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="crmProductVerification"
                    id="inlineRadio2"
                    value="false"
                    onChange={(e) => partnerChange(e)}
                    checked={addPartnerData.crmProductVerification == "false"}
                  />
                  <label className="form-check-label" htmlFor="inlineRadio2">
                    Disable
                  </label>
                </div>
              </Col>
              <Col>
                <label className="mt-3">Partner Headers </label>
                <textarea
                  rows="4"
                  cols="50"
                  name="partnerHeaders"
                  className="search-button partner-search"
                  placeholder="Partner Headers..."
                  value={addPartnerData.partnerHeaders || ""}
                  onChange={(e) => partnerChange(e)}
                />

                <br />
                <span style={{ color: "red" }}>
                  {errMsg.partnerHeaders
                    ? errMsg.partnerHeaders
                    : coolMaxLength}
                </span>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="default" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleSubmit}>
                {isSubmit ? "Loading..." : "Submit"}
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            className="dms-modalsss"
            show={historyShow}
            onHide={handleHistoryClose}
          >
            <Modal.Header closeButton style={{ backgroundColor: "#f7fcfd" }}>
              <Modal.Title>View Partner History</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ textAlign: "" }}>
              <Col>
                <table id="employee" className="table table-bordered">
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Username</th>
                      <th>Action Details</th>
                      <th>Action Date</th>
                      <th>Action Time</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="default" onClick={handleHistoryClose}>
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        </Layout>
        <div className="mobile-view container">
          <h3>{localization.label.myLead}</h3>
          <div className="my-lead-wrap">
            {!checkEmpty(dataList) &&
              dataList.map((data, index) => (
                <PartnerBox data={data} key={index} history={history} />
              ))}
          </div>
        </div>
      </MainLayout>
    </BaseUrl.Provider>
  );
};

export default Partners;
